import React, { useRef, useEffect, useState } from "react";
import { Paper, Button, Typography, Box } from "@material-ui/core";
import { useFormik } from "formik";
import useStyles from "@/styles/alarmStyle";
import SearchInput from "@/components/SearchInput";
import { useTranslation } from "@/langs/useTranslation";
import { FormItem } from "@/components/Form";
import DateRangePicker from "@/components/DateRangePicker";
import { useGlobalState } from "@/GlobalProvider";
import SingleSelector from "@/components/SingleSelector";
import { TableContent } from "@/containers/Announcement/TableContent";

const AnnouncementTable = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const tableRef = useRef(null);
  const isReset = useRef(true);
  const [isUnread, setIsUnread] = useState(true);

  const initialValues = {
    type: "",
    keywords: "",
    activeTime: undefined
  };

  const { currentCompanyId } = useGlobalState();

  const { values, handleChange, handleSubmit, handleReset } = useFormik({
    initialValues,
    onSubmit: () => {
      handleReloadDataTable();
    }
  });

  const getSearchParams = () => {
    const formValues = isReset.current ? initialValues : values;
    const { activeTime } = formValues;
    return {
      keywords: formValues.keywords,
      startTime: activeTime ? activeTime[0]?.valueOf() : null,
      endTime: activeTime ? activeTime[1]?.valueOf() : null,
      isUnread,
      type: formValues.type
    };
  };

  const reloadTableWithGroupId = () => {
    isReset.current = false;
    tableRef.current?.reload();
  };

  const resetTableWithGroupId = () => {
    isReset.current = true;
    tableRef.current?.reload();
  };

  const handleReloadDataTable = reset => {
    if (reset) {
      resetTableWithGroupId();
    } else {
      reloadTableWithGroupId();
    }
  };

  const resetQuery = () => {
    handleReset();
    handleReloadDataTable(true);
  };

  const typeOptions = [
    { id: "", name: t({ defaultMessage: "全部通知类型" }) },
    { id: "Platform Notification", name: t({ defaultMessage: "平台公告" }) },
    { id: "Alarm Notification", name: t({ defaultMessage: "报警通知" }) }
  ];

  useEffect(() => {
    resetQuery();
  }, [currentCompanyId]); // eslint-disable-line

  useEffect(() => {
    tableRef.current?.reload();
  }, [isUnread]);

  return (
    <div className={classes.main}>
      <form onSubmit={handleSubmit}>
        <Box display="flex" alignItems="center" marginBottom={1}>
          <Typography variant="h4">
            {t({ defaultMessage: "通知中心" })}
          </Typography>
          <Box display="flex" alignItems="center" marginLeft="auto">
            <SearchInput
              placeholder={t({ defaultMessage: "搜索" })}
              name="keywords"
              icon={null}
              value={values.keywords}
              onChange={handleChange}
              style={{ marginRight: 16 }}
            />
          </Box>
        </Box>
        <Box display="flex" alignItems="center" marginBottom={1}>
          <div
            className={
              isUnread ? classes.selectedTitleButton : classes.titleButton
            }
            onClick={() => setIsUnread(true)}
          >
            {t({ defaultMessage: "未读" })}
          </div>
          <div
            className={
              isUnread ? classes.titleButton : classes.selectedTitleButton
            }
            onClick={() => setIsUnread(false)}
          >
            {t({ defaultMessage: "已读" })}
          </div>
        </Box>
        <Paper elevation={0}>
          {/*<div className={classes.tableHeader}>*/}
          <div>
            <div className={classes.tableQueryForm}>
              <FormItem
              // label={t({defaultMessage: "类型"})}
              // className={classes.formItem}
              >
                <SingleSelector
                  placeholder={t({ defaultMessage: "请选择通知类型" })}
                  options={typeOptions}
                  clearable
                  style={{ width: 165 }}
                  name="type"
                  value={values.type}
                  onChange={handleChange}
                />
              </FormItem>
              <FormItem
              // label={t({defaultMessage: ""})}
              // className={classes.formItem}
              >
                <DateRangePicker
                  name="activeTime"
                  value={values.activeTime}
                  onChange={handleChange}
                  startPlaceholder={t({ defaultMessage: "请选择开始时间" })}
                  endPlaceholder={t({ defaultMessage: "请选择结束时间" })}
                />
              </FormItem>
              <FormItem
              // className={classes.formItem}
              >
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{ marginRight: 8, width: 100 }}
                >
                  {t({ defaultMessage: "查询" })}
                </Button>
                <Button
                  variant="outlined"
                  onClick={resetQuery}
                  style={{ width: 100 }}
                >
                  {t({ defaultMessage: "重置" })}
                </Button>
              </FormItem>
            </div>
          </div>
          <TableContent ref={tableRef} getSearchParams={getSearchParams} />
        </Paper>
      </form>
    </div>
  );
};

export default AnnouncementTable;
